<app-lfsa-card [innTemplate]="reporte" [titulo]="titulo" [efecto]="true" [colapseName]="'reporte'" [banderaColapse]='true'>
</app-lfsa-card>

<ng-template #reporte>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-3'">
        <app-lfsa-input [type]="'number'" [class]="'letrasSuccess'" [placeholder]="'Ingrese Año'" [label]="'Año*'" 
        [id]="'anio'" formControlName="anio" [control]="formulario.get('anio')">
        </app-lfsa-input>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'descCorta'" [idOpcion]="'idUnidad'" [comboBox]="cmbxUnidadNegocio"
          formControlName="unidadNegocio" [control]="formulario.get('unidadNegocio')" [label]="'Unidad de Negocio*'" [id]="'unidadNegocio'">
        </app-lfsa-combo-box>
      </div>
      

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'dscaCanalVenta'" [idOpcion]="'idCanalVenta'" [comboBox]="cmbxCanalVenta"
          formControlName="canal" [control]="formulario.get('canal')" [label]="'Canal Venta'" [id]="'canal'">
        </app-lfsa-combo-box>
      </div>

      <!--
      T25111 | ALCANCE: comentar definiciones de cabecera de plantilla y reporte. Omite campos CANAL, SUBCANAL Y GRUPO CLIENTES
      NO BORRAR, SE ESPERA A FUTURO ACTIVAR

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'descCorta'" [idOpcion]="'idCanal'" [comboBox]="cmbxCanal"
          formControlName="canalVendedor" [control]="formulario.get('canalVendedor')" [label]="'Canal Vendedor'" [id]="'canalVendedor'">
        </app-lfsa-combo-box>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'dscaGrupoCanal'" [idOpcion]="'idTarCanal'" [comboBox]="cmbxSubCanal"
          formControlName="subCanal" [control]="formulario.get('subCanal')" [label]="'Sub Canal '" [id]="'subCanal'">
        </app-lfsa-combo-box>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-input [type]="'number'" [class]="'letrasSuccess'" [placeholder]="'11000003'" [label]="'Ingrese material*'" 
        [id]="'material'" formControlName="material" [control]="formulario.get('material')">
        </app-lfsa-input>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'dscaGrupoCliente'" [idOpcion]="'idGrupoCliente'" [comboBox]="cmbxgrupoCliente"
          formControlName="grupoCliente" [control]="formulario.get('grupoCliente')" [label]="'Grupo Cliente*'" [id]="'grupoCliente'">
        </app-lfsa-combo-box>
      </div>
      -->
      <!-- END -->
      
      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button [disabled]="this.formulario.invalid" (click)="getReport()" class="btn btn-success btn-block">
          <i class="fa fa-search"></i>Buscar</button>
      </div>

      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button [disabled]="this.rowData.length === 0" (click)="downloadDataCsv()" class="btn btn-success btn-block">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar Csv
        </button>
      </div>
      
    </div>
  </form>


  <hr>
  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Indicadores.
    </div>

    <ag-grid-angular *ngIf="!listaVacia" #agGrid class="{{modulo.agGrid.class}}"
      #agGridConsulta [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
      [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"  [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize] = "modulo.agGrid.paginacion" >
    </ag-grid-angular>
  </div>

</ng-template>